import { createSlice } from '@reduxjs/toolkit';

const loadCart = () => {
  try {
    const saved = localStorage.getItem('osesg_cart');
    return saved ? JSON.parse(saved) : { items: [] };
  } catch {
    return { items: [] };
  }
};

const saveCart = (items) => {
  try { localStorage.setItem('osesg_cart', JSON.stringify({ items })); } catch {}
};

const cartSlice = createSlice({
  name: 'cart',
  initialState: loadCart(),
  reducers: {
    addToCart: (state, action) => {
      const { productId, name, nameAr, osesgCode, image, unitPrice, quantity = 1,
        specifications = '', supplierId, moq = 1, quoteId = null, customization = null } = action.payload;
      // A line with a customization attached is always its own cart entry —
      // never merged with a plain (or differently-customized) line for the
      // same product, since each customization has its own price/approval.
      const customizationCost = customization?.price || 0;
      const existing = !customization
        ? state.items.find(i => i.productId === productId && !i.customization)
        : null;
      if (existing) {
        existing.quantity += quantity;
        existing.totalPrice = existing.quantity * existing.unitPrice;
      } else {
        state.items.push({
          productId, name, nameAr, osesgCode, image,
          unitPrice, quantity, totalPrice: unitPrice * quantity + customizationCost,
          specifications, supplierId, moq, quoteId, customization
        });
      }
      saveCart(state.items);
    },
    removeFromCart: (state, action) => {
      const { productId, customizationRequestId = null } = typeof action.payload === 'object'
        ? action.payload : { productId: action.payload };
      state.items = state.items.filter(i =>
        !(i.productId === productId && (i.customization?.requestId || null) === customizationRequestId)
      );
      saveCart(state.items);
    },
    updateQuantity: (state, action) => {
      const { productId, quantity, customizationRequestId = null } = action.payload;
      const item = state.items.find(i =>
        i.productId === productId && (i.customization?.requestId || null) === customizationRequestId
      );
      if (item && quantity > 0) {
        item.quantity = quantity;
        item.totalPrice = item.unitPrice * quantity + (item.customization?.price || 0);
      }
      saveCart(state.items);
    },
    clearCart: (state) => {
      state.items = [];
      saveCart(state.items);
    }
  }
});

export const { addToCart, removeFromCart, updateQuantity, clearCart } = cartSlice.actions;
export const selectCartCount = (state) => state.cart.items.reduce((sum, i) => sum + i.quantity, 0);
export const selectCartTotal = (state) => state.cart.items.reduce((sum, i) => sum + i.totalPrice, 0);
export default cartSlice.reducer;
